import React from "react";
import { TimerInfoState } from "../../../timer-controller";

interface LeftItemProps {
  title: string;
  value?: string;
  isShort: boolean;
}

const LeftItem: React.FC<LeftItemProps> = ({ title, value, isShort }) => {
  return (
    <div className={`item-wrapper ${isShort ? "small" : ""}`}>
      <div className="title">{title}</div>
      <div className="value">{value}</div>
    </div>
  );
};

// Tournament Header도 함께 분리
interface TournamentHeaderProps {
  cafeName?: string;
  tournamentTitle?: string;
  subTitle?: string;
  coverImage?: string | null;
}

const TournamentHeader: React.FC<TournamentHeaderProps> = ({
  cafeName,
  tournamentTitle,
  subTitle,
  coverImage,
}) => {
  return (
    <div className="header">
      {coverImage && <img src={coverImage} alt="로고" />}
      <div className="title">
        <div className="pub-name">{cafeName}</div>
        <div className="tournament">{tournamentTitle}</div>
        <div className="type">{subTitle}</div>
      </div>
    </div>
  );
};

// Left Wrapper 전체를 관리하는 컴포넌트
interface LeftWrapperProps {
  cafeName?: string;
  tournamentTitle?: string;
  timerInfo: TimerInfoState;
  coverImage?: string | null;
  subTitle?: string;
  playerCounts: {
    userCount: number;
    reBuyInUserCount: number;
    entryUserCount: number;
    adOnUserCount: number;
  };
  stack: number;
  avgStack: number;
}

const LeftWrapper: React.FC<LeftWrapperProps> = ({
  cafeName,
  tournamentTitle,
  timerInfo,
  subTitle,
  playerCounts,
  stack,
  avgStack,
  coverImage,
}) => {
  return (
    <div className="left-wrapper">
      <TournamentHeader
        coverImage={coverImage}
        cafeName={cafeName}
        tournamentTitle={tournamentTitle}
        subTitle={subTitle}
      />
      <LeftItem
        title="PLAYERS"
        value={`${playerCounts.userCount} / ${
          playerCounts.adOnUserCount +
          playerCounts.entryUserCount +
          playerCounts.reBuyInUserCount
        }`}
        isShort={false}
      />
      <LeftItem
        title="TOTAL TIME"
        value={timerInfo.elapsedTime || "00:00:00"}
        isShort={true}
      />
      <LeftItem
        title="TOTAL STACKS"
        value={stack?.toLocaleString()}
        isShort={true}
      />
      <LeftItem
        title="AVG STACKS"
        value={avgStack.toLocaleString()}
        isShort={true}
      />
      <LeftItem
        title="NEXT BREAK"
        value={timerInfo.timeUntilNextBreak || "00:00:00"}
        isShort={false}
      />
    </div>
  );
};

export default LeftWrapper;
